import { render, staticRenderFns } from "./Training.vue?vue&type=template&id=50ace464&scoped=true&"
import script from "./Training.vue?vue&type=script&lang=js&"
export * from "./Training.vue?vue&type=script&lang=js&"
import style0 from "./Training.vue?vue&type=style&index=0&id=50ace464&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ace464",
  null
  
)

export default component.exports